import type { FlagRecord } from "@/hooks/useFeatureFlags/flags";

export const AMPLITUDE_FEATURE_FLAGS_PROPERTY = "feature_flags";

/**
 * Keys of the flags that are on for the signed-in user, sorted so an unchanged set serializes the same.
 * Returns undefined when no flag was evaluated: `initializeFeatures` swallows Flagr errors and leaves the
 * record empty, and an empty record must not wipe the flags already on the Amplitude profile.
 */
export function getEnabledFlagKeys(flags: FlagRecord | null | undefined): string[] | undefined {
  const evaluatedKeys = Object.keys(flags ?? {});
  if (!flags || evaluatedKeys.length === 0) {
    return undefined;
  }

  return evaluatedKeys.filter((key) => Boolean(flags[key as keyof FlagRecord])).sort();
}

export function setFeatureFlagIdentifyProperty(
  identify: {
    set: (property: string, value: string[]) => unknown;
    unset: (property: string) => unknown;
  },
  enabledFlagKeys: readonly string[]
) {
  if (enabledFlagKeys.length === 0) {
    identify.unset(AMPLITUDE_FEATURE_FLAGS_PROPERTY);
    return;
  }

  identify.set(AMPLITUDE_FEATURE_FLAGS_PROPERTY, [...enabledFlagKeys]);
}
